import { IStandardAPIResponse, IPreventiveMaintenenceSchedule } from "../../vm";
import { httpClient, handleErrorResp, httpFileUpload } from "../UtilService";

export async function getAllPMScheduleFile(searchObj: {
  datacenterId?: string;
  customerId?: string;
  date: Date | string;
  isFromDatacenter: boolean;
}): Promise<IStandardAPIResponse<Array<IPreventiveMaintenenceSchedule>>> {
  try {
    let res = await httpClient<Array<IPreventiveMaintenenceSchedule>>(
      `preventive-maintenence-schdule`,
      "GET",
      searchObj
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function addPMScheduleFile(
  data: IPreventiveMaintenenceSchedule
): Promise<IStandardAPIResponse<IPreventiveMaintenenceSchedule>> {
  try {
    let res = await httpClient<IPreventiveMaintenenceSchedule>(
      `preventive-maintenence-schdule`,
      "PUT",
      data
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export async function deletePMScheduleFile(data: {
  customerId: string;
  documentId: string;
}): Promise<IStandardAPIResponse<IPreventiveMaintenenceSchedule>> {
  try {
    let res = await httpClient<IPreventiveMaintenenceSchedule>(
      `preventive-maintenence-schdule/${data.customerId}/${data.documentId}`,
      "DELETE"
    );
    return res;
  } catch (err) {
    return handleErrorResp([]);
  }
}

export const uploadPMSFile = async (file: File): Promise<any> => {
  try {
    let res = await httpFileUpload<any>(`uploads-pms`, "POST", { file }, true);
    return res;
  } catch (err: any) {
    return err && err.response ? err.response.data : undefined;
  }
};
